var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"advantages-wrap moveRight",style:({backgroundColor: _vm.bgcolor})},[_c('div',{staticClass:"advantages-inner"},[_c('h2',[_vm._v("PBSD 研发团队")]),_c('h3',[_vm._v("R&D Team of PBSD")]),_c('TeamItems')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }